import { Chip } from '@mui/material'
import { BaseTooltip } from 'feedback'
import { sx } from 'utils'

const STATI_STRUMENTO = {
  ATTIVO: 'ATTIVO',
  DISATTIVATO: 'DISATTIVATO',
}

const COLOR_STATI_STRUMENTO = {
  [STATI_STRUMENTO.ATTIVO]: 'success',
  [STATI_STRUMENTO.DISATTIVATO]: 'warning',
}

const LABEL_STATI_STRUMENTO = {
  [STATI_STRUMENTO.ATTIVO]: 'Attivo',
  [STATI_STRUMENTO.DISATTIVATO]: 'Disattivato',
}

const INFO_STATI_STRUMENTO = {
  [STATI_STRUMENTO.ATTIVO]: 'Selezionabile in nuove pratiche: SI',
  [STATI_STRUMENTO.DISATTIVATO]: 'Selezionabile in nuove pratiche: NO',
}

const OPTIONS_STATI_STRUMENTO = Object.values(STATI_STRUMENTO).map(value => ({
  value,
  label: LABEL_STATI_STRUMENTO[value]
}))

function LabelStatoStrumento(props) {
  const {
    stato,
    grande,
    ...restProps
  } = props

  let label
  let color
  let info
  if (STATI_STRUMENTO[stato]) {
    label = LABEL_STATI_STRUMENTO[stato]
    color = COLOR_STATI_STRUMENTO[stato]
    info = INFO_STATI_STRUMENTO[stato]
  }

  return (
    <>
      {label && color && info &&
        <BaseTooltip contenuto={info} placement='right'>
          <Chip
            label={label}
            color={color}
            size={grande ? 'medium' : 'small'}
            {...restProps}
            {...sx(restProps, grande && { fontSize: '1.25rem' })}
          />
        </BaseTooltip>
      }
    </>
  )
}

export {
  STATI_STRUMENTO,
  OPTIONS_STATI_STRUMENTO,
  LabelStatoStrumento
}